import React, { Component } from 'react'
import PropTypes from 'prop-types'

import s from './Video.module.css'

class Video extends Component {
  constructor(props) {
    super(props)
    this.video = props.video
  }

  render() {
    return (
      <video
        key={this.video.sourceUrl}
        className={s.video}
        autoPlay
        playsInline
        muted
        loop
        controls
      >
        <source src={this.video.sourceUrl} type={this.video.videoType} />
      </video>
    )
  }
}

Video.propTypes = {
  video: PropTypes.object,
}

export default Video
